import React, { useCallback } from 'react';
import {
  createStyles, makeStyles, ListItemText, MenuItem,
} from '@material-ui/core';

const useStyles = makeStyles(createStyles({
  link: {
    padding: '1px 3px',
    margin: '0px',
    borderRadius: 'unset',
  },
  iconStart: {
    paddingRight: '0.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  iconEnd: {
    paddingLeft: '0.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    color: '#3C3C3C',
  },
  listItem: {
    height: 32,
    '&:hover': {
      backgroundColor: 'rgba(0,168,190,0.05)',
    },
    paddingLeft: '5px',
    cursor: 'pointer',
  },
}), { name: 'Action' });

type Props = {
  icon?: React.ReactNode;
  title?: string | React.ReactNode;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  iconPosition?: 'start' | 'end';
  children?: React.ReactNode;
};

const Action = ({
  icon,
  title = '',
  disabled = false,
  onClick,
  iconPosition = 'start',
  children,
}: Props) => {
  const classes = useStyles();

  const clickHandler = useCallback((e: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      onClick?.(e);
    }
  }, [disabled, onClick]);

  return (
    <MenuItem
      onClick={clickHandler}
      className={classes.listItem}
      disabled={disabled}
    >
      {(icon && iconPosition === 'start') && (<span className={classes.iconStart}>{icon}</span>)}
      <ListItemText className={classes.title}>
        {title}
      </ListItemText>
      {(icon && iconPosition === 'end') && (<span className={classes.iconEnd}>{icon}</span>)}
      {children}
    </MenuItem>
  );
};

export default Action;
